<template>
  <el-container class="container">
    <el-main>
      <div class="box">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="执行方法">
              <el-input v-model="formData.service_method" placeholder="service.method" required></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行用户">
              <el-select v-model="formData.user_id" placeholder="请选择用户" clearable>
                <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="flex: 1;overflow: auto">
          <KfJsonEditor style="min-height: 100%" placeholder="运行参数，json格式" v-model="formData.json" ></KfJsonEditor>
        </el-row>
        <el-row style="padding-top:20px">
          <div style="text-align: center;width: 100%">
            <el-button @click="onDebug" style="width: 100px;height: 36px;font-size: 18px">调试运行</el-button>
          </div>
        </el-row>
      </div>
    </el-main>
    <el-aside>
      <div ref="msgList" class="msg-list">
        <KfJsonEditor style="min-height: 100%" v-model="exeLogs" ></KfJsonEditor>
      </div>
    </el-aside>
  </el-container>
</template>

<script>
import EventSource from 'eventsource';
import {nanoid} from "nanoid";

export default {
  name: "SysDebug",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        service_method: 'sysDebugService.test',
        user_id: '',
        json: '{}',
        jsonObj:{}
      },
      userList: [],
      exeLogs: ''
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.userList = await this.$http('sysDsService.getUserAll', {});
    },
    async onDebug() {
      if (!this.formData.service_method) {
        this.$message.error('执行方法不能为空')
        return;
      }

      this.exeLogs = '';

      //先用post方式保存参数，然后再用get请求，获取动态日志
      try{
        this.formData.jsonObj = JSON.parse(this.formData.json);
      }catch (e) {
        this.$message.error('json格式错误')
        return;
      }

      let requestId = await this.$http('sysDebugService.saveParams', this.formData);
      console.log("requestId=" + requestId)

      let baseUrl = window.location.protocol + '//' + window.location.host + process.env.VUE_APP_AXIOS_BASE_URL;
      let url = baseUrl + `debug/run/` + requestId + "?token=" + localStorage.getItem('token');

      const eventSource = new EventSource(url);
      eventSource.onmessage = (event) => {
        let data = event.data;
        console.log(data)

        this.exeLogs = this.exeLogs + data + "\n";

        if (data === '[DONE]') {
          eventSource.close();
        }

      };
      eventSource.onerror = (error) => {
        //console.error('Error了', error, '====', eventSource.readyState)
        //this.$message.error('执行失败。' + error)
        eventSource.close();
      };

      //this.scrollToBottom()

    }
    /*
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.msgList) {
          this.$refs.msgList.scrollTop = this.$refs.msgList.scrollHeight;
        }
      });

    }*/
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}

.el-main {
  border-right: 2px dotted #ddd;

  .box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}


.el-aside {
  width: 60%;
  display: flex;
  flex-direction: column;

  .empty-tip {
    font-size: 24px;
    color: #ccc;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

.send-box {
  display: flex;
  padding: 20px;
}

.msg-list {
  flex: 1;
  overflow: auto;

  .msg-item {
    display: flex;
    padding: 20px 20px 0 20px;

    .icon {
      width: 50px;
      text-align: center;
    }

    .content-box {
      flex: 1;
      white-space: pre-wrap;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 20px;
    }

    .content-box .content {
      border-radius: 15px;
      padding: 10px;
    }

    .content-box.user {
      display: flex;
      justify-content: flex-end;
    }

    .content-box.user .content {
      background-color: AliceBlue;
    }

    .content-box.assistant {

    }

    .content-box.assistant .content {
      background-color: #F4F4F4;
    }

  }

  .msg-item:last-child .content-box {
    border-bottom: none;
  }
}

</style>